module.exports = __webpack_public_path__ + "img/logo.2d41c427.png";